export default "__VITE_ASSET__BptVRKW8__"